<template>
  <div>
    <head>
      <!-- Meta and CSS Preload Links -->
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>سفارة معرفة مكتبة الإسكندرية بجامعة العلمين الدولية | بوابة المعرفة والبحث العلمي</title>

      <!-- Favicon and Touch Icons -->
      <link rel="apple-touch-icon" sizes="180x180" href="/images/Fav/apple-touch-icon.png">
      <link rel="icon" type="image/png" sizes="32x32" href="/images/Fav/favicon-32x32.png">
      <link rel="icon" type="image/png" sizes="16x16" href="/images/Fav/favicon-16x16.png">
      <link rel="manifest" href="/images/Fav/site.webmanifest">
      <link rel="mask-icon" href="/images/Fav/safari-pinned-tab.svg" color="#5bbad5">
      <meta name="msapplication-TileColor" content="#da532c">
      <meta name="theme-color" content="#ffffff">

      <!-- SEO Meta Tags -->
      <meta name="description" content="سفارة معرفة مكتبة الإسكندرية بجامعة العلمين الدولية تقدم خدمات المعلومات والبحث العلمي، وصولاً لمصادر المعرفة، ودعم الابتكار وريادة الأعمال للطلاب والباحثين">
      <meta name="keywords" content="سفارة المعرفة, مكتبة الإسكندرية, جامعة العلمين الدولية, البحث العلمي, مصادر المعلومات, قواعد البيانات, الابتكار, ريادة الأعمال, ورش عمل, تدريبات طلابية, مكتبة رقمية">
      <meta name="author" content="سفارة معرفة مكتبة الإسكندرية بجامعة العلمين الدولية">
      
      <!-- Open Graph / Facebook -->
      <meta property="og:type" content="website">
      <meta property="og:url" content="https://www.alamein.edu.eg/knowledge-embassy/">
      <meta property="og:title" content="سفارة معرفة مكتبة الإسكندرية بجامعة العلمين الدولية">
      <meta property="og:description" content="بوابة المعرفة والبحث العلمي لطلاب جامعة العلمين الدولية">
      <meta property="og:image" content="/images/social-share.jpg">

      <!-- Twitter -->
      <meta property="twitter:card" content="summary_large_image">
      <meta property="twitter:url" content="https://www.alamein.edu.eg/knowledge-embassy/">
      <meta property="twitter:title" content="سفارة معرفة مكتبة الإسكندرية بجامعة العلمين الدولية">
      <meta property="twitter:description" content="بوابة المعرفة والبحث العلمي لطلاب جامعة العلمين الدولية">
      <meta property="twitter:image" content="/images/social-share.jpg">

      <!-- Stylesheets -->
      <link rel="stylesheet" href="/css/bootstrap.min.css">
      <link rel="stylesheet" href="/css/fontawsom-all.min.css">
      <link rel="stylesheet" href="/plugins/slider/css/owl.carousel.min.css">
      <link rel="stylesheet" href="/plugins/slider/css/owl.theme.default.css">
      <link rel="stylesheet" href="/css/style.css">
    </head>
    <nav class="navbar knowledge-nav">
      <div class="container">
        <div class="navbar-content">
          <div class="logo-container">
            <router-link to="/">
              <img :src="logoSrc" alt="شعار سفارة معرفة مكتبة الإسكندرية بجامعة العلمين الدولية" class="logo" />
            </router-link>
          </div>
          <div class="nav-right">
            <div class="dropdown" @click="toggleMenu">
              <i class="fas fa-bars dropbtn"></i>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div v-if="menuOpen" class="menu knowledge-menu" dir=rtl>
      <a href="#about" class="mobile-nav-link" @click="handleNavClick">
        نبذة عن سفارات المعرفة
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>  
      </a>
      <a href="#goals" class="mobile-nav-link" @click="handleNavClick">
        أهداف سفارة المعرفة
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
          <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
        </svg>
      </a>
      <a href="#services" class="mobile-nav-link" @click="handleNavClick">
        الخدمات
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
          <line x1="8" y1="21" x2="16" y2="21"></line>
          <line x1="12" y1="17" x2="12" y2="21"></line>
        </svg>
      </a>
      <a href="#activities" class="mobile-nav-link" @click="handleNavClick">
      الأنشطة والفعاليات
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
        </svg>
      </a>
      <a href="#registration" class="mobile-nav-link" @click="handleNavClick">
       الحجز
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
      </a>
      <router-link v-if="!isAuthenticated" to="/adminpanel" class="mobile-login-button" @click="closeMenu">
        <span>تسجيل الدخول</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
          <polyline points="10 17 15 12 10 7"></polyline>
          <line x1="15" y1="12" x2="3" y2="12"></line>
        </svg>
      </router-link>
      <router-link v-else-if="$route.path === '/'" to="/adminpanel" class="mobile-login-button" @click="closeMenu">
        <span>لوحة التحكم</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      </router-link>
      <a v-else @click="handleLogout" class="mobile-login-button mobile-logout-button" style="cursor: pointer;">
        <span>تسجيل الخروج</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
          <polyline points="16 17 21 12 16 7"></polyline>
          <line x1="21" y1="12" x2="9" y2="12"></line>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KnowledgeEmbassyNavbar',
  data() {
    return {
      logoSrc: require('../../images/logo.png'),
      menuOpen: false,
      isAuthenticated: false
    };
  },
  mounted() {
    this.checkAuthentication();
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    checkAuthentication() {
      this.isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true';
    },
    handleLogout() {
      sessionStorage.removeItem('isAuthenticated');
      this.isAuthenticated = false;
      this.closeMenu();
      if (this.$route.path.startsWith('/adminpanel')) {
        this.$router.push('/');
      }
    },
    handleNavClick(event) {
      event.preventDefault();
      const href = event.currentTarget.getAttribute('href');
      if (this.$route.path.startsWith('/adminpanel')) {
        this.$router.push('/' + href);
      }
      this.closeMenu();
    }
  }
};
</script>

<style scoped>
.knowledge-nav {
  background-color: #f8f9fa;
  border-bottom: 3px solid #0056b3;
  padding: 15px 0;
  box-shadow: 0 2px 10px rgba(0, 86, 179, 0.1);
  width: 100%;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.navbar-content {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding: 10px 0;
}

.logo {
  max-height: 180px;
  max-width: 100%;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.03);
}

.nav-right {
  position: absolute;
  right: 15px;
  display: flex;
  align-items: center;
}

.dropdown {
  cursor: pointer;
  font-size: 24px;
  color: #0056b3;
  transition: color 0.3s ease;
}

.dropdown:hover {
  color: #003366;
}

.knowledge-menu {
  background-color: #f8f9fa;
  width: 100%;
  padding: 15px 0;
  box-shadow: 0px 4px 10px rgba(0, 86, 179, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid #dee2e6;
}

.mobile-nav-link {
  color: #333;
  padding: 12px 15px;
  text-decoration: none;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s ease;
}

.mobile-nav-link:hover {
  background-color: #e9ecef;
  color: #0056b3;
  padding-right: 20px;
}

.mobile-nav-link svg {
  transition: transform 0.3s ease;
}

.mobile-nav-link:hover svg {
  transform: scale(1.1);
}

.mobile-login-button {
  background-color: #0056b3;
  color: white;
  padding: 12px 20px;
  border-radius: 5px;
  margin: 10px 0;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s ease;
}

.mobile-login-button:hover {
  background-color: #003d7a;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 86, 179, 0.2);
}

.mobile-logout-button {
  background-color: #c42326 !important;
  color: white !important;
}

.mobile-logout-button:hover {
  background-color: #a81b1b !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(196, 35, 38, 0.2);
}

@media (max-width: 768px) {
  .logo {
    max-height: 150px;
  }
  
  .logo-container {
    padding: 5px 0;
  }
  
  .navbar-content {
    justify-content: space-between;
  }
  
  .logo-container {
    margin: 0;
    width: 100%;
    text-align: center;
  }
  
  .nav-right {
    position: static;
  }
}

@media (min-width: 769px) {
  .knowledge-menu {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    padding: 10px 0;
  }
  
  .mobile-nav-link {
    width: auto;
    border-bottom: none;
    padding: 10px 15px;
    text-align: center;
    justify-content: center;
  }
  
  .mobile-login-button {
    margin: 0 10px;
  }
}

.account-btn {
  background-color: #0f106c;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 1rem;
}

.account-btn:hover {
  background-color: #23248c;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(15, 16, 108, 0.15);
}

.account-btn svg {
  width: 20px;
  height: 20px;
}
</style>